import { HorizontalRule as HR } from "@tiptap/extension-horizontal-rule";
import { calcYchangeDomAttrs } from "../../Collaboration/YChange";
import { mergeAttributes } from "@tiptap/core";

// add ychange attribute for horizontal rule
export const HorizontalRule = HR.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      ychange: {
        default: null,
      },
    };
  },
  renderHTML({ node }) {
    const renderChanges = node.content.size === 0;
    const attrs = renderChanges ? calcYchangeDomAttrs(node.attrs) : node.attrs;
    return ["hr", mergeAttributes(this.options.HTMLAttributes, attrs)];
  },
});
